import { Button, Card, Field, Input, Menu, MenuItem, MenuList, MenuPopover, MenuProps, MenuTrigger, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { useContext, useEffect, useState } from "react";
import {


    BookAdd24Filled, BookAdd24Regular,
    bundleIcon,
} from "@fluentui/react-icons";
import { CWClientContext } from "../App";
const BookAddIcon = bundleIcon(BookAdd24Filled, BookAdd24Regular);

type AddMasterCardProp = {
    maker: string | undefined,
    brandYomi: string | undefined,
    brand: string | undefined,
    item: string | undefined,
    color: string | undefined,
    onAddMaster: (maker: string, brand: string, item: string, color: string) => void,
}

const useStyles = makeStyles({
    registerMasterCard: {
        ...shorthands.margin("15px"),
        ...shorthands.borderRadius("12px"),
        boxShadow: tokens.shadow8,

    },
});

const AddMasterCard = (prop: AddMasterCardProp) => {
    const styles = useStyles();

    const [newMaker, setNewMaker] = useState<string>();
    const [newBrandYomi, setNewBrandYomi] = useState<string>();
    const [newBrand, setNewBrand] = useState<string>();
    const [newItem, setNewItem] = useState<string>();
    const [newColor, setNewColor] = useState<string>();
    const [newItemCategory, setNewItemCategory] = useState<string>();
    const [newProductCategory, setNewProductCategory] = useState<string>();

    // const [openMakerSuggest, setOpenMakerSuggest] = useState(false);
    // const [openBrandSuggest, setOpenBrandSuggest] = useState(false);
    // const [openItemSuggest, setOpenItemSuggest] = useState(false);
    // const [openColorSuggest, setOpenColorSuggest] = useState(false);
    const [openProductCategorySuggest, setOpenProductCategorySuggest] = useState(false);
    // const [openItemCategorySuggest, setOpenItemCategorySuggest] = useState(false);

    const cwClient = useContext(CWClientContext);

    useEffect(() => {

        setNewMaker(prop.maker);
        setNewBrandYomi(prop.brand);
        setNewBrand(prop.brand);
        setNewItem(prop.item);
        setNewColor(prop.color);
        setNewItemCategory("");
        setNewProductCategory("");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const addMaster = (
        maker: string,
        brandYomi: string,
        brand: string,
        item: string,
        color: string | undefined,
        productCategory: string | undefined,
        itemCategory: string | undefined,
    ) => {
        console.log("addMaster called.");
        (async () => {
            cwClient.addMaster(
                maker, brandYomi, brand, item, color,
                productCategory, itemCategory
            ).then((master) => {
                // TODO toast;
                // 元帳検索を更新
                prop.onAddMaster(maker, brand, item, color ?? "");
            })
        })();
    }
    const [suggests, setSuggest] = useState<string[]>([]);

    const suggest = (column: string, keyword: string): string[] => {
        (async () => {
            cwClient.suggest(column, keyword).then((suggestions) => {
                console.log("suggestions = ", suggestions);
                setSuggest(suggestions);
            });
        })();

        return [];
    };

    const onOpenChange: MenuProps["onOpenChange"] = (e, data) => {
    }


    return (
        <>
            <Card className={styles.registerMasterCard}>
                <Field
                    label="メーカー名"
                >
                    <Input placeholder="メーカー" defaultValue={prop.maker}
                        value={newMaker}
                        onChange={(e, data) => {
                            setNewMaker(data.value);
                        }}
                    />
                </Field>



                <Field
                    label="ブランド読み"
                >
                    <Input placeholder="ブランド読み" defaultValue={prop.brand}
                        value={newBrandYomi}
                        onChange={(e, data) => {
                            setNewBrandYomi(data.value);
                        }}
                    />
                </Field>
                <Field
                    label="ブランド名"
                >
                    <Input placeholder="ブランド" defaultValue={prop.brand}
                        value={newBrand}
                        onChange={(e, data) => {
                            setNewBrand(data.value);
                        }}
                    />
                </Field>
                <Field
                    label="商品名"
                >
                    <Input placeholder="商品名" defaultValue={prop.item}

                        value={newItem}
                        onChange={(e, data) => {
                            setNewItem(data.value);
                        }}
                    />
                </Field>
                <Field label="色番">
                    <Input placeholder="色番" defaultValue={prop.color}
                        value={newColor}
                        onChange={(e, data) => {
                            setNewColor(data.value);
                        }}
                    />
                </Field>
                <Field label="商品カテゴリ">
                    <Menu
                        open={openProductCategorySuggest}
                    >
                        <MenuTrigger
                            disableButtonEnhancement
                        >
                            <Input placeholder="商品カテゴリ" defaultValue=""
                                value={newProductCategory}
                                onChange={(e, data) => {
                                    setNewProductCategory(data.value);
                                    if (newProductCategory !== undefined) {
                                        suggest("productCategory", newProductCategory);
                                        setOpenProductCategorySuggest(true);
                                    }
                                }}
                            />
                        </MenuTrigger>
                        <MenuPopover>
                            <MenuList
                            >
                                {suggests.map((s) => {
                                    return (
                                        <MenuItem
                                            onClick={() => {
                                                setNewProductCategory(s);
                                                setOpenProductCategorySuggest(false);
                                            }}
                                        >{s}</MenuItem>
                                    );
                                })}
                            </MenuList>
                        </MenuPopover>
                    </Menu>
                </Field>

                <Field label="アイテムカテゴリ">
                    <Input placeholder="アイテムカテゴリ" defaultValue=""
                        value={newItemCategory}
                        onKeyUp={(e) => {
                            if (newItemCategory !== undefined) {

                            }
                        }}

                        onChange={(e, data) => {
                            setNewItemCategory(data.value);
                        }}
                    />
                </Field>

                <Button
                    icon={<BookAddIcon />}
                    onClick={() => {
                        if (newMaker !== undefined
                            && newBrandYomi !== undefined
                            && newBrand !== undefined
                            && newItem !== undefined
                            && newProductCategory !== undefined
                            && newItemCategory !== undefined
                        ) {
                            addMaster(
                                newMaker,
                                newBrandYomi,
                                newBrand,
                                newItem,
                                newColor,
                                newProductCategory,
                                newItemCategory,
                            );
                        } else {
                            // TODO toast
                        }
                    }

                    }
                >元帳に新規登録</Button>
            </Card >
        </>
    )
}

export default AddMasterCard; 